import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import AccountLayout from "components/layout/AccountLayout";
import { Loading } from "components/StatusScreen";
import Button from "components/ui/Button";
import OrderTable from "features/transactions/OrderTable";
import PaymentSuccess from "features/transactions/PaymentSuccess";
import useCourseInfo from "features/transactions/useCourseInfo";
import { ordersApi } from "api";
import { FRONT_URL } from "lib/config";
import { statusOrders, fetchOrders, messageOrder } from "store/actions/orders";

export default function Transactions() {
  const dispatch = useDispatch();
  const ORDERS = useSelector((state) => state.orders);
  const orderId = new URLSearchParams(useLocation().search).get("order_id");

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(statusOrders("loading"));
    ordersApi
      .all()
      .then((res) => dispatch(fetchOrders(res.data)))
      .catch((err) => dispatch(messageOrder(err?.response?.data?.message ?? "error")));
  }, [dispatch]);

  const list = Object.values(ORDERS.data ?? {}).sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
  const metaOf = useCourseInfo(list);
  const paid = orderId && ORDERS.data?.[orderId];

  return (
    <AccountLayout title="Order history">
      {ORDERS.status === "loading" && <Loading />}
      {ORDERS.status === "error" && (
        <p className="yc-alert is-error" role="alert">
          Could not load your transactions. Please refresh the page.
        </p>
      )}
      {ORDERS.status === "ok" &&
        (paid ? (
          <PaymentSuccess order={paid} meta={metaOf(paid)} />
        ) : list.length === 0 ? (
          <div className="yc-empty">
            <h2 className="yc-h2">No transactions yet</h2>
            <p className="yc-muted">Free classes don&apos;t need payment, so they won&apos;t show up here.</p>
            <Button href={`${FRONT_URL}/courses`}>Browse classes</Button>
          </div>
        ) : (
          <OrderTable orders={list} metaOf={metaOf} />
        ))}
    </AccountLayout>
  );
}
